var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    _vm._l(_vm.parameters, function(item, index) {
      return _c(
        "div",
        { staticClass: "placeholder-item" },
        [
          item.formatParameter.formatParameterType === "Text"
            ? _c("campaign-parameters-text", {
                attrs: { formatParameter: item.formatParameter },
                model: {
                  value: _vm.value.parameters[_vm.getParameterIndex(item)],
                  callback: function($$v) {
                    _vm.$set(
                      _vm.value.parameters,
                      _vm.getParameterIndex(item),
                      $$v
                    )
                  },
                  expression: "value.parameters[getParameterIndex(item)]"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          item.formatParameter.formatParameterType === "Image"
            ? _c("campaign-parameters-image", {
                attrs: {
                  formatParameter: item.formatParameter,
                  previewPath: _vm.assetsPath
                },
                model: {
                  value: _vm.value.parameters[_vm.getParameterIndex(item)],
                  callback: function($$v) {
                    _vm.$set(
                      _vm.value.parameters,
                      _vm.getParameterIndex(item),
                      $$v
                    )
                  },
                  expression: "value.parameters[getParameterIndex(item)]"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          item.formatParameter.formatParameterType === "Video"
            ? _c("campaign-parameters-video", {
                attrs: {
                  formatParameter: item.formatParameter,
                  previewPath: _vm.assetsPath
                },
                model: {
                  value: _vm.value.parameters[_vm.getParameterIndex(item)],
                  callback: function($$v) {
                    _vm.$set(
                      _vm.value.parameters,
                      _vm.getParameterIndex(item),
                      $$v
                    )
                  },
                  expression: "value.parameters[getParameterIndex(item)]"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          item.formatParameter.formatParameterType === "SeenThisStream"
            ? _c("campaign-parameters-seenthis", {
                attrs: {
                  formatParameter: item.formatParameter,
                  previewPath: _vm.assetsPath
                },
                model: {
                  value: _vm.value.parameters[_vm.getParameterIndex(item)],
                  callback: function($$v) {
                    _vm.$set(
                      _vm.value.parameters,
                      _vm.getParameterIndex(item),
                      $$v
                    )
                  },
                  expression: "value.parameters[getParameterIndex(item)]"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          item.formatParameter.formatParameterType === "Choice"
            ? _c("campaign-parameters-choice", {
                attrs: { formatParameter: item.formatParameter },
                model: {
                  value: _vm.value.parameters[_vm.getParameterIndex(item)],
                  callback: function($$v) {
                    _vm.$set(
                      _vm.value.parameters,
                      _vm.getParameterIndex(item),
                      $$v
                    )
                  },
                  expression: "value.parameters[getParameterIndex(item)]"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          item.formatParameter.formatParameterType === "InsTag"
            ? _c("campaign-parameters-instag", {
                attrs: { formatParameter: item.formatParameter },
                model: {
                  value: _vm.value.parameters[_vm.getParameterIndex(item)],
                  callback: function($$v) {
                    _vm.$set(
                      _vm.value.parameters,
                      _vm.getParameterIndex(item),
                      $$v
                    )
                  },
                  expression: "value.parameters[getParameterIndex(item)]"
                }
              })
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }